// src/hooks/useProduct.js
import { useState, useEffect } from 'react';
import { getProduct } from '../services/api';

export function useProduct(slug) {
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!slug) return;

    let isMounted = true;

    const fetchProduct = async () => {
      setLoading(true);
      setError('');
      try {
        const res = await getProduct(slug);
        if (isMounted) setProduct(res.data);
      } catch (e) {
        if (isMounted) setError(e?.response?.data?.detail || e?.message || 'Failed');
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    fetchProduct();
    return () => { isMounted = false; };
  }, [slug]);

  return { product, loading, error };
}